type DiagramStub = {identifier?: string};

type ModelStub = {diagrams?: DiagramStub[]};

function parseModel(initialJson: object | string | undefined): ModelStub | null {
	if (initialJson == null) return null;
	if (typeof initialJson === 'string') {
		try {
			return JSON.parse(initialJson) as ModelStub;
		} catch {
			return null;
		}
	}
	return initialJson as ModelStub;
}

/** Индекс view в `model.diagrams` по `identifier` из URL, иначе 0. */
export function resolveViewIndexFromModel(
	initialJson: object | string | undefined,
	viewIdFromUrl: string | undefined
): number {
	const model = parseModel(initialJson);
	const diagrams = model?.diagrams;
	if (!diagrams?.length) return 0;
	if (!viewIdFromUrl?.trim()) return 0;
	const i = diagrams.findIndex(d => d?.identifier === viewIdFromUrl);
	return i >= 0 ? i : 0;
}
